import PropTypes from "prop-types";
import styles from "./index.css";

// This is required for links that are external to prevent the links reappearing during navigation for screenreaders.
const removeFocus = event => event.currentTarget.blur();

const AccessibilityLinks = ({ defaultStoreUrl, formatTranslation }) => (
  <section className={styles.skipContainer}>
    <a
      href="#chrome-app-container"
      className={styles.skipLink}
      data-testid="skip-to-content"
    >
      {formatTranslation("accessibility_skip_to_content")}
    </a>
    <a
      href={defaultStoreUrl.concat(
        formatTranslation("legalbar_accessibility_link")
      )}
      className={styles.skipLink}
      data-testid="skip-to-accessibility-statement"
      onClick={removeFocus}
    >
      {formatTranslation("accessibility_statement")}
    </a>
  </section>
);

AccessibilityLinks.propTypes = {
  defaultStoreUrl: PropTypes.string.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default AccessibilityLinks;
